<template>
  <v-container fluid>
    <v-layout column>
      <v-card class="pa-5">
        <v-card-text>
          <v-flex class="mb-4">
            <v-avatar size="96" class="mr-4 d-inline-flex">
              <img :src="profilePicture" v-if="user.profilePicture" />
              <b-icon v-if="!user.profilePicture" icon="person-fill"></b-icon>
            </v-avatar>
            <v-file-input class="d-inline-flex" clearable prepend-icon="mdi-camera" accept="image/png" v-model="profileImage" @change="onAvatarChange">
              <template v-slot:label>{{ $t('profile.avatar') }}</template>
            </v-file-input>
          </v-flex>
          <v-row>
            <v-col xs="12" sm="6" md="4" lg="3">
              <v-text-field v-model="user.username">
                <template v-slot:label>{{ $t('profile.username') }}</template>
              </v-text-field>
            </v-col>
            <v-col xs="12" sm="6" md="4" lg="3">
              <v-text-field v-model="user.firstName">
                <template v-slot:label>{{ $t('profile.firstName') }}</template>
              </v-text-field>
            </v-col>
            <v-col xs="12" sm="6" md="4" lg="3">
              <v-text-field v-model="user.lastName">
                <template v-slot:label>{{ $t('profile.lastName') }}</template>
              </v-text-field>
            </v-col>
            <v-col xs="12" sm="6" md="4" lg="3">
              <v-text-field autocomplete="off" type="password" v-model="user.password">
                <template v-slot:label>{{ $t('profile.password') }}</template>
              </v-text-field>
            </v-col>
            <v-col xs="12" sm="6" md="4" lg="3">
              <v-text-field v-model="user.email">
                <template v-slot:label>{{ $t('profile.email') }}</template>
              </v-text-field>
            </v-col>
            <v-col xs="12" sm="6" md="4" lg="3">
              <v-text-field v-model="user.company">
                <template v-slot:label>{{ $t('profile.company') }}</template>
              </v-text-field>
            </v-col>
            <v-col xs="12" sm="6" md="4" lg="3">
              <v-text-field v-model="user.roleName" readonly>
                <template v-slot:label>{{ $t('profile.role') }}</template>
              </v-text-field>
            </v-col>
            <v-col v-if="canUploadSignature" xs="12" sm="6" md="4" lg="3">
              <v-img class="mr-4 d-inline-flex">
                <img :src="userSignature" v-if="user.signature" style="width: 150px; height: 50px" />
                <v-icon large v-if="!user.signature">user</v-icon>
              </v-img>
              <v-file-input clearable class="d-inline-flex" prepend-icon="mdi-camera" accept="image/png" v-model="signatureImage" @change="onSignatureChange">
                <template v-slot:label>{{ $t('profile.signature') }}</template>
              </v-file-input>
            </v-col>
          </v-row>
          <v-row>
            <label>{{ $t('nav.projects') }}</label>
            <v-list class="sc prj-vessels">
              <v-list-item v-for="p in projects" :key="p.PVId">
                <v-list-item-content>
                  <label :for="p.Id">{{ p.ProjectName }} - {{ p.VesselName }}</label>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" :loading="loading" @click.native="save">
            <v-icon left dark>check</v-icon>
            {{ $t('profile.save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-layout>
  </v-container>
</template>
<script>
import { mapMutations, mapActions, mapGetters } from 'vuex'
var userRole = require('../store/modules/user-role/user-roles')

export default {
  pageTitle: 'My Profile',
  data() {
    return {
      loading: false,
      showAvatarPicker: false,
      user: {},
      profileImage: null,
      signatureImage: null
    }
  },
  computed: {
    ...mapGetters(['getLoggedInUser', 'm_user/getUser', 'm_user/getUserProjects', 'm_role/getRoles']),

    canUploadSignature() {
      return this.user.roleName && userRole.CLIENT_VIEWER_ROLE == this.user.roleName;
    },

    projects() {
      return this['m_user/getUserProjects']
    },

    profilePicture() {
      let pp = this.user.profilePicture
      if (!pp || pp.indexOf('data:image') !== -1) {
        return this.user.profilePicture
      }

      return 'data:image/png;base64,' + this.user.profilePicture
    },
    userSignature() {
      let sgn = this.user.signature
      if (!sgn || sgn.indexOf('data:image') !== -1) {
        return this.user.signature
      }

      return 'data:image/png;base64,' + this.user.signature
    }
  },
  created() {
    this.user = this.getLoggedInUser
    this['m_user/fetchUserProjects'](this.user.id)
  },
  methods: {
    ...mapActions(['m_user/getUserById', 'm_user/updateUser', 'm_user/fetchUserProjects', 'm_role/fetchRoles', 'm_userInRole/fetchUserInRoles']),
    ...mapMutations(['mHideLongLoader']),

    save() {
      let pp = this.user.profilePicture || ''
      this.user.profilePicture = pp.replace(/data:image\/png;base64,/gi, '')

      let sgn = this.user.signature || ''
      this.user.signature = sgn.replace(/data:image\/png;base64,/gi, '')

      this['m_user/updateUser'](this.user)
    },

    onAvatarChange() {
      this.$log.debug('avatar changed', this.profileImage)

      if (!this.profileImage) {
        this.user.profilePicture = null
        return
      }

      var self = this
      var reader = new FileReader()
      reader.onload = function (e) {
        self.user.profilePicture = e.target.result
      }

      reader.readAsDataURL(this.profileImage)
    },
    onSignatureChange() {
      this.$log.debug('signature changed', this.signatureImage)

      if (!this.signatureImage) {
        this.user.signature = null
        return
      }

      var self = this
      var reader = new FileReader()
      reader.onload = function (e) {
        self.user.signature = e.target.result
      }

      reader.readAsDataURL(this.signatureImage)
    }
  }
}
</script>
